import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import carrieThumb from 'images/carrie_thumb16.jpeg';
import { type CardLayoutModelConstructorType } from '../../types';

export class OwnerImage extends Field {
  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    return { owner: ['name', 'avatarUrl', 'initials'] };
  }

  get title() {
    return 'Owner image';
  }

  exampleContents(): FieldContentsData {
    return {
      avatar: { src: carrieThumb, name: 'Assigned to user', initials: 'UN' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    const { owner } = record;
    if (owner) {
      return {
        avatar: {
          src: owner.avatarUrl,
          name: owner.name,
          initials: owner.initials,
        },
      };
    }

    return {};
  }
}
